import React, { useState, useEffect } from 'react';  
import { useNavigate, Link } from "react-router-dom";
import { getEventsinner } from "../Service/Api"; 
import Header from "../Component/Header";
import LazyLoad from 'react-lazyload';
const SchoolEvents = () => {
  useEffect(() => {
    document.title = 'School Events - The Air Force School Subroto Park ';  
}, []);  
const navigate = useNavigate();  
const [filterData, setFilteredData] = useState([]);  
const [openModel, setOpenmodal] = useState(false); 
const [selectedItem, setSelectedItem] = useState(null); 
const [data, setData] = useState([]); 
const [selectedYear, setSelectedYear] = useState();
const [selectedMonth, setSelectedMonth] = useState("All");
const [monthOptions, setMonthOptions] = useState(["All"]);
const [yearRanges, setYearRanges] = useState([]);
const [searchQuery, setSearchQuery] = useState("");
const [archivedData, setArchivedData] = useState([]);
const [loading, setLoading] = useState(true); // Loading state

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Get current year for default selection
useEffect(() => {
  const currentYear = new Date().getFullYear();
  setSelectedYear(`${currentYear}`);
}, []);

// Fetch data and set the gallery data
useEffect(() => {
  const fetchData = async () => {
    try {
      const galleryData = await getEventsinner(); 
      
      setData(galleryData);

      // Get unique years and months for filtering
      const yearsSet = new Set();
      const monthsSet = new Set();

      galleryData.forEach(item => {
        if (item.date) {
          const date = new Date(item.date); 
          yearsSet.add(date.getFullYear());
          monthsSet.add(date.getMonth());
        }
      });

      const uniqueYearRanges = Array.from(yearsSet).sort((a, b) => b - a);
      setYearRanges(uniqueYearRanges);

      const monthOptions = Array.from(monthsSet).sort((a, b) => a - b).map(month => monthNames[month]);
      setMonthOptions(["All", ...monthOptions]);

      setLoading(false); // Data has been fetched, update loading state
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  fetchData();
}, []);

useEffect(() => {
  let filteredData = data;
  
  // Separate archived and valid data
  const archived = filteredData.filter(item => !item.date); // Archived items (no date)
  const validData = filteredData.filter(item => item.date); // Valid items (with date)
  
  if (selectedYear === "All" && selectedMonth === "All" && searchQuery === "") {
    filteredData = [...validData];
  }

  // If "Archive" is selected, show only archived data
  if (selectedYear === "Archive") {
    setFilteredData([]);
    setArchivedData(archived);
    return;
  }

  // Get current month and year
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth(); // 0-based index (Jan = 0)

  // Separate current month data
  const currentMonthData = validData.filter(item => {
    const itemDate = item.date?.trim();
    if (itemDate) {
      const date = new Date(itemDate);
      const itemYear = date.getFullYear();
      const itemMonth = date.getMonth();
      return itemYear === currentYear && itemMonth === currentMonth;
    }
    return false;
  });

  // Filter the rest of the data (not in current month)
  const restOfTheData = validData.filter(item => {
    const itemDate = item.date?.trim();
    if (itemDate) {
      const date = new Date(itemDate);
      const itemYear = date.getFullYear();
      const itemMonth = date.getMonth();
      return itemYear !== currentYear || itemMonth !== currentMonth;
    }
    return false;
  });

  // Sort the rest of the data in ascending order
  restOfTheData.sort((a, b) => new Date(a.date) - new Date(b.date));

  // Combine current month data and the rest
  const combinedData = [...currentMonthData, ...restOfTheData];

  // Apply filtering based on year, month, and search query
  if (selectedYear !== "All") {
    const year = parseInt(selectedYear);
    filteredData = combinedData.filter(item => {
      const itemDate = item.date?.trim();
      if (itemDate) {
        const date = new Date(itemDate);
        const itemYear = date.getFullYear();
        const itemMonth = date.getMonth();
        return itemYear === year && (selectedMonth === "All" || monthNames[itemMonth] === selectedMonth);
      }
      return false;
    });
  }

  // If a month is selected but no year, filter by month
  if (selectedMonth !== "All" && selectedYear === "All") {
    filteredData = combinedData.filter(item => {
      const itemDate = item.date?.trim();
      if (itemDate) {
        const itemMonth = new Date(itemDate).getMonth();
        return monthNames[itemMonth] === selectedMonth;
      }
      return false;
    });
  }

  // If the "All" year is selected but specific month, filter by year
  if (selectedYear !== "All" && selectedMonth === "All") {
    filteredData = combinedData.filter(item => {
      const itemDate = item.date?.trim();
      if (itemDate) {
        const date = new Date(itemDate);
        const itemYear = date.getFullYear();
        return itemYear === parseInt(selectedYear);
      }
      return false;
    });

    // Sort the data by month in ascending order
    filteredData.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateA.getMonth() - dateB.getMonth();
    });
  }

  // Search filtering
  if (searchQuery) {
    filteredData = filteredData.filter(item => {
      return item.title && item.title.toLowerCase().includes(searchQuery.toLowerCase());
    });
  }

  // ✅ Sort by date descending (latest first)
  filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));

  // Set filtered data
  setFilteredData(filteredData);
  setArchivedData(archived); // Set archived data separately
}, [selectedYear, selectedMonth, searchQuery, data]);

const handleModal = id => {
  navigate(`/SubGallery?id=${id}`);
};

const modalPopup = (item) => {
  setSelectedItem(item); // Set the clicked item's data
  setOpenmodal(true); // Open the modal
};

const handleClose = () => {
  setOpenmodal(false);
  setSelectedItem(null); // Clear the selected item
};

const emptyArray = [
  { id: 1 },
  { id: 2 },
  { id: 3 },
];

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

  return (
     <>
    
       <Header/>
<div className="innerslide">
     <ul className="breadcrumb">
         <li><Link to="/"> Home</Link> </li> 
             
          <li>School Events</li>
     </ul>
 </div> 
 <div className="innersec">
     <div className="container">
         <div className="row">
             <div className="col-lg-12">
                 <h1>School Events</h1>
             </div>
         </div>
             <div className="row tabs-dynamic">
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="count-val">
                <p>Total Categories: {filterData.length}</p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="yearSelection"
                >
                  
                  {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>{yr}</option>
                  ))}
                  <option value="Archive">Archive</option>
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  className="monthSelect"
                >
                  {monthOptions.map((month, index) => (
                    <option key={index} value={month}>{month}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="searchBox">
                <input
                  type="text"
                  id="myInput"
                  name="name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search Here.."
                />
              </div>
            </div>
          </div>    
       {loading ? (
        <div><img src="https://webapi.entab.info/api/image/TAFS/public/Images/loading.gif" className="img-fluid loadingimg"/></div>
 ) : (
   selectedYear === "Archive" && archivedData.length > 0 && (
     <div className="row years year2024 showYear">
       {archivedData.map((item, index) => {
         return (
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount" key={index}>
                <div className="eventsnewsbox">
                    <div className="newsboximg">
                        {item.images.length > 0 ? (
                            <LazyLoad>
                                <img src={`https://webapi.entab.info/api/image/${item.images[0]}`} className="img-fluid" alt="TAFS" />
                            </LazyLoad>
                        ) : (
                            <LazyLoad>
                                <img src="https://webapi.entab.info/api/image/TAFS/public/Images/events.jpg" className="img-fluid" alt="TAFS" />
                            </LazyLoad>
                        )}
                    </div>
                    <div className="newsboxdesc">
                        <div className="newspgh">
                            <h5>{item.title}</h5>
                            <p>{item.description}</p>
                            <button onClick={() => modalPopup(item)} className="readmorebtn">Read More</button>
                            
                        </div>
                        <div className="newsdate">
                            <span><i className="bi bi-calendar"></i> {formatDate(item.date)}</span>
                            <span><i className="bi bi-alarm"></i> {item.time}</span>
                            {item.attachments && item.attachments[0] && (
                                <a href={`https://webapi.entab.info/api/image/${item.attachments[0]}`} target="_blank">
                                    <i className="bi bi-paperclip"></i>
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
                   
                    );
                  })}
                </div>
              )
            )}
            {selectedYear !== "Archive" && filterData.length > 0 && (
              <div className="row years year2024 showYear">
                {filterData.map((item, index) => {
                  const date = new Date(item.date);
                  const day = date.getDate();
                  const month = monthNames[date.getMonth()];
                  return (
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount" key={index}>
                    <div className="eventsnewsbox">
                        <div className="newsboximg">
                            {item.images.length > 0  ?  (
                                <LazyLoad>
                                    <img src={`https://webapi.entab.info/api/image/${item.images[0]}`} className="img-fluid" alt="TAFS" />
                                </LazyLoad>
                            ) : (
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/TAFS/public/Images/events.jpg" className="img-fluid" alt="TAFS" />
                                </LazyLoad>
                            )}
                        </div>
                        <div className="newsboxdesc">
                            <div className="newspgh">
                                <h5>{item.title}</h5>
                                <p className="Schoolevent"><div dangerouslySetInnerHTML={{ __html:item.description}} /> </p>
                                <button onClick={() => modalPopup(item)} className="readmorebtn">Read More</button>
                                
                            </div>
                            <div className="newsdate">
                                <span><i className="bi bi-calendar"></i> {formatDate(item.date)}</span>
                                <span><i className="bi bi-alarm"></i> {item.time}</span>
                                {item.attachments && item.attachments[0] && (
                                    <a href={`https://webapi.entab.info/api/image/${item.attachments[0]}`} target="_blank">
                                        <i className="bi bi-paperclip"></i>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                  );
                })}
              </div>
            )} 
            </div> 
</div> 
{openModel && selectedItem && (
  <div className="eventPopup">
    <div className="eventpopupbody">
      <div className="eventpopupcontent">
        <button onClick={handleClose} className="closebtn">X</button>
        <div className="schooleventbox">
        <div className="schooleventrightbox">
        <h5><div dangerouslySetInnerHTML={{ __html: selectedItem.title }} /> </h5>
            <p> <div dangerouslySetInnerHTML={{ __html: selectedItem.description }} /></p>
            {selectedItem.attachments && selectedItem.attachments[0] && ( 
              <div className="attachment popupattch">
              <Link to={`https://webapi.entab.info/api/image/${selectedItem?.attachments}`} target="_blank"> Click Here To View</Link>
          </div>
            )} 
        </div>
        {selectedItem.images && selectedItem.images.length > 0  && selectedItem.images.length === 1 ? (
          selectedItem.images.map((image, index) => (
            <div key={index} className="schooleventleftbox galleryCount sub-gallerycount">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src={`https://webapi.entab.info/api/image/${image}`} // Using image source for gallery
                  data-group="a"
                  href={`https://webapi.entab.info/api/image/${image}`}
                >
                  <img
                    src={`https://webapi.entab.info/api/image/${image}`}
                    className="img-fluid float-start"
                    alt={`Image ${index + 1} of The Air Force School Subroto Park`} // Dynamic alt text
                  />
                </a>
              </LazyLoad>
            </div>
          ))
        ) : null}
        {selectedItem.images && selectedItem.images.length > 0  && selectedItem.images.length > 1 ? (
          selectedItem.images.map((image, index) => (
            <div key={index} className="schooleventleftbox galleryCount sub-gallerycount  multi-img">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src={`https://webapi.entab.info/api/image/${image}`} // Using image source for gallery
                  data-group="a"
                  href={`https://webapi.entab.info/api/image/${image}`}
                >
                  <img
                    src={`https://webapi.entab.info/api/image/${image}`}
                    className="img-fluid"
                    alt={`Image ${index + 1} of The Air Force School Subroto Park`} // Dynamic alt text
                  />
                </a>
              </LazyLoad>
            </div>
          ))
        ) : null}
         
        </div>
        
         <div className="row">
         {selectedItem.galleryAttachments?.length > 0 && (
              selectedItem.galleryAttachments.map((item,index) => (
                <div
                key={index}
                className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"
              >
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href={`https://webapi.entab.info/api/image/${item}`}><img src={`https://webapi.entab.info/api/image/${item}`} className=" img-fluid" alt="The Air Force School Subroto Park" /></a>
                  </LazyLoad>
              </div> 
              ))
    )}
         </div>
      </div>
    </div>
  </div>
)}
    </>
  )
}

export default SchoolEvents
